/* XNote Write PDP review feed (#all-reviews). Ported from v2 ia-customer-reviews.js + ia-review-photos.js, namespaced
   xp-rfeed. Review text is never changed; only its collapsed presentation. Without this script the first six show. */
(() => {
  'use strict';
  const COLLAPSED_DESKTOP = 4, COLLAPSED_PHONE = 3, PAGE_SIZE = 6;
  const phone = matchMedia('(max-width:767px)');
  const fmt = new Intl.DateTimeFormat('tr-TR', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });

  /* ---- Photo lightbox (one dialog for the page) ---- */
  let dialog, lastTrigger;
  function setupDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'xp-rfeed-dialog';
    dialog.setAttribute('aria-label', 'Müşteri fotoğrafı');
    dialog.innerHTML = '<header><span></span><button type="button" aria-label="Müşteri fotoğrafını kapat">×</button></header><figure><img alt=""></figure><p hidden>Fotoğraf yüklenemedi. Lütfen tekrar deneyin.</p>';
    document.body.append(dialog);
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => lastTrigger && lastTrigger.focus());
    dialog.querySelector('img').addEventListener('error', () => { dialog.querySelector('p').hidden = false; });
  }
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-xp-rfeed-photo]');
    if (!trigger) return;
    if (!dialog) setupDialog();
    lastTrigger = trigger;
    const who = trigger.dataset.xpRfeedAuthor || 'Bir XNote müşterisi';
    const img = dialog.querySelector('img');
    dialog.querySelector('header span').textContent = who + ' tarafından paylaşılan fotoğraf';
    img.alt = who + ' tarafından paylaşılan XNote fotoğrafı';
    dialog.querySelector('p').hidden = true;
    img.src = trigger.dataset.xpRfeedPhoto;
    dialog.showModal();
  });

  const SET_NAMES = ['XNote Full Set', 'XNote Smart Writing Set', 'XNote Akıllı Kalem ve Defter Seti'];
  const CHECK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';

  document.querySelectorAll('[data-xp-rfeed]').forEach(root => {
    const q = s => root.querySelector(s);
    const section = root.closest('section') || document;
    const list = q('[data-xp-rfeed-list]');
    let entries = [...list.children];
    const search = q('[data-xp-rfeed-search]'), sort = q('[data-xp-rfeed-sort]'), photos = q('[data-xp-rfeed-photos]');
    const prev = q('[data-xp-rfeed-prev]'), next = q('[data-xp-rfeed-next]'), clear = q('[data-xp-rfeed-clear]');
    const more = q('[data-xp-rfeed-more]'), pager = q('[data-xp-rfeed-pager]'), controls = q('[data-xp-rfeed-controls]');
    const count = q('[data-xp-rfeed-count]'), empty = q('[data-xp-rfeed-empty]'), pageLabel = q('[data-xp-rfeed-page]');
    const barsBox = section.querySelector('[data-xp-rfeed-bars]');
    const bars = barsBox ? [...barsBox.querySelectorAll('[data-xp-rfeed-bar]')] : [];
    let page = 1, expanded = false, rating = 'all', photosOnly = false, allLoaded = false;

    /* Card layout: stars + date on top, an initial avatar and a verified tick by the name, a chip for reviews of
       another XNote product. Text is never changed. */
    const decorate = entry => {
      const copy = entry.querySelector('.xp-rfeed__copy'), person = entry.querySelector('.xp-rfeed__person');
      const stars = copy.querySelector('.xp-rfeed__stars'), time = person.querySelector('time');
      const top = document.createElement('div'); top.className = 'xp-rfeed__top';
      if (stars) top.append(stars);
      if (time) { time.textContent = fmt.format(new Date(time.dateTime + 'T00:00:00Z')); top.append(time); }
      copy.prepend(top);
      const name = person.querySelector('strong'), badge = person.querySelector('span');
      const av = document.createElement('span'); av.className = 'xp-rfeed__av'; av.setAttribute('aria-hidden', 'true');
      av.textContent = (name ? name.textContent.trim().charAt(0) : '·').toUpperCase();
      person.prepend(av);
      const who = document.createElement('span'); who.className = 'xp-rfeed__who';
      if (name) who.append(name);
      if (badge) { badge.className = 'xp-rfeed__ok'; badge.insertAdjacentHTML('afterbegin', CHECK); who.append(badge); }
      person.append(who);
      const product = entry.dataset.reviewProduct;
      if (product && !SET_NAMES.includes(product)) {
        const chip = document.createElement('span'); chip.className = 'xp-rfeed__prod'; chip.textContent = product;
        person.append(chip);
      }
    };
    entries.forEach(decorate);

    /* Star bars: share of each rating in this list; a click filters, a second click clears. */
    if (bars.length) {
      bars.forEach(b => {
        const n = b.dataset.xpRfeedBar, c = entries.filter(r => r.dataset.rating === n).length;
        /* The store's real distribution (Judge.me histogram over every review) when the section passes it;
           otherwise the share in this list. */
        const pct = b.dataset.xpRfeedPct !== undefined ? Number(b.dataset.xpRfeedPct)
          : (entries.length ? Math.round((c / entries.length) * 100) : 0);
        b.querySelector('.xp-rv__track i').style.width = pct + '%';
        b.querySelector('.xp-rv__pct').textContent = '%' + pct;
        b.setAttribute('aria-label', n + ' yıldız: değerlendirmelerin %' + pct + ' kadarı. Yalnızca bunları göster');
        b.disabled = c === 0;
        b.addEventListener('click', () => { rating = rating === n ? 'all' : n; reset(); });
      });
      barsBox.hidden = false;
    }

    /* Long reviews collapse to a few lines with "Read full review" (v2 behaviour). */
    const disclose = (entry, i) => {
      const copy = entry.querySelector('.xp-rfeed__copy'), title = copy.querySelector('h3'), body = copy.querySelector('p');
      const norm = t => t.replace(/[\s.!…]+$/g, '').trim().toLocaleLowerCase();
      if (norm(body.textContent).startsWith(norm(title.textContent)) || /^[\s.…]*$/.test(title.textContent)) entry.classList.add('is-untitled');
      title.id = 'xp-rfeed-title-' + i; body.id = 'xp-rfeed-body-' + i;
      const btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'xp-rfeed__more'; btn.textContent = 'Devamını Oku'; btn.hidden = true;
      btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-controls', body.id);
      body.after(btn);
      entry.classList.add('is-collapsible');
      btn.addEventListener('click', () => {
        const open = entry.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        btn.textContent = open ? 'Daha Az Göster' : 'Devamını Oku';
      });
      return { entry, body, btn };
    };
    const disclosures = entries.map(disclose);
    function refreshDisclosures() {
      disclosures.forEach(({ entry, body, btn }) => {
        if (!entry.getClientRects().length || entry.classList.contains('is-open')) return;
        btn.hidden = !(body.scrollHeight > body.clientHeight + 1);
      });
    }

    function update() {
      const query = search.value.trim().toLocaleLowerCase();
      const filtered = entries.filter(r =>
        (rating === 'all' || r.dataset.rating === rating) &&
        (!photosOnly || r.dataset.hasPhoto === 'true') &&
        (!query || r.textContent.toLocaleLowerCase().includes(query))
      ).sort((a, b) => {
        if (sort.value === 'featured') { const o = Number(a.dataset.featuredRank || 999) - Number(b.dataset.featuredRank || 999); if (o) return o; }
        if (sort.value === 'photos') { const o = Number(b.dataset.hasPhoto === 'true') - Number(a.dataset.hasPhoto === 'true'); if (o) return o; }
        if (sort.value === 'lowest') { const o = Number(a.dataset.rating) - Number(b.dataset.rating); if (o) return o; }
        if (sort.value === 'highest') { const o = Number(b.dataset.rating) - Number(a.dataset.rating); if (o) return o; }
        return b.dataset.date.localeCompare(a.dataset.date);
      });
      const compactSize = phone.matches ? COLLAPSED_PHONE : COLLAPSED_DESKTOP;
      const collapsed = !expanded && filtered.length > compactSize;
      const size = collapsed ? compactSize : PAGE_SIZE;
      const pages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
      page = Math.min(page, pages);
      const start = collapsed ? 0 : (page - 1) * PAGE_SIZE;
      entries.forEach(r => { r.hidden = true; });
      const shown = filtered.slice(start, start + size);
      shown.forEach(r => { r.hidden = false; list.append(r); });
      const filtering = rating !== 'all' || photosOnly || query;
      const scope = [query ? '“' + search.value.trim() + '” geçen' : '', rating !== 'all' ? rating + ' yıldızlı' : '', photosOnly ? 'fotoğraflı' : ''].filter(Boolean).join(' ');
      const pre = scope ? scope + ' ' : '';
      /* Judge.me total (every review) vs the newest ones listed here: say so instead of implying the list is all. */
      const total = Number(root.dataset.xpRfeedTotal || 0);
      const partial = !filtering && !allLoaded && total > entries.length;
      const shownTotal = !filtering && allLoaded && total > filtered.length ? total : filtered.length;
      if (!filtered.length) count.textContent = scope ? pre + 'değerlendirme yok' : 'Değerlendirme yok';
      else if (partial && collapsed) count.textContent = total.toLocaleString('tr-TR') + ' değerlendirmeden en yeni ' + shown.length + ' tanesi gösteriliyor';
      else if (partial) count.textContent = total.toLocaleString('tr-TR') + ' değerlendirmeden en yeni ' + filtered.length + ' tanesi · ' + (start + 1) + '–' + (start + shown.length) + ' arası';
      else if (filtering) count.textContent = 'En yeni değerlendirmeler arasında ' + pre + filtered.length + ' sonuç' + (collapsed ? ', ' + shown.length + ' tanesi gösteriliyor' : ' · ' + (start + 1) + '–' + (start + shown.length) + ' arası');
      else if (collapsed) count.textContent = shownTotal.toLocaleString('tr-TR') + ' değerlendirmeden ' + shown.length + ' tanesi gösteriliyor';
      else count.textContent = shownTotal.toLocaleString('tr-TR') + ' değerlendirmeden ' + (start + 1) + '–' + (start + shown.length) + ' arası';
      clear.hidden = !filtering;
      empty.hidden = filtered.length > 0;
      more.hidden = !collapsed;
      more.textContent = partial ? 'En yeni ' + filtered.length + ' değerlendirmeyi gör' : 'Tüm değerlendirmeleri gör (' + shownTotal.toLocaleString('tr-TR') + ')';
      pager.hidden = collapsed || pages < 2;
      pageLabel.textContent = 'Sayfa ' + page + ' / ' + pages;
      prev.disabled = page <= 1; next.disabled = page >= pages;
      bars.forEach(b => { const on = b.dataset.xpRfeedBar === rating; b.setAttribute('aria-pressed', String(on)); b.classList.toggle('is-on', on); });
      if (barsBox) barsBox.classList.toggle('is-filtering', rating !== 'all');
      photos.setAttribute('aria-pressed', String(photosOnly));
      requestAnimationFrame(refreshDisclosures);
    }
    const reset = () => { page = 1; update(); };
    sort.addEventListener('change', reset);
    search.addEventListener('input', reset);
    photos.addEventListener('click', () => { photosOnly = !photosOnly; reset(); });
    clear.addEventListener('click', () => { rating = 'all'; photosOnly = false; search.value = ''; reset(); search.focus(); });
    const toTop = () => root.scrollIntoView({ block: 'start', behavior: 'instant' });
    prev.addEventListener('click', () => { page--; update(); toTop(); });
    next.addEventListener('click', () => { page++; update(); toTop(); });
    more.addEventListener('click', () => { expanded = true; update(); });
    phone.addEventListener('change', update);
    let width = 0;
    new ResizeObserver(([o]) => { if (o.contentRect.width !== width) { width = o.contentRect.width; refreshDisclosures(); } }).observe(root);
    if (document.fonts) document.fonts.ready.then(refreshDisclosures);

    /* Every review, not only the ~25 newest the theme renders: Judge.me's public widget feed (CORS open), fetched once
       when the section nears the viewport, 30 per page. Cards are built like the Liquid ones; text is never changed. */
    const shopDomain = root.dataset.xpRfeedShop, pid = root.dataset.xpRfeedPid;
    const esc = t => String(t == null ? '' : t).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
    const seen = new Set(entries.map(r => r.dataset.date + '|' + (r.querySelector('.xp-rfeed__copy p') || {}).textContent.trim().slice(0, 40)));
    function build(r, rank) {
      const tmp = document.createElement('div'); tmp.innerHTML = r.body_html || '';
      const body = tmp.textContent.trim();
      if (body.length < 3) return null;
      const date = String(r.created_at || '').slice(0, 10);
      const key = date + '|' + body.slice(0, 40);
      if (seen.has(key)) return null;
      seen.add(key);
      let prod = r.product_title || '';
      if (prod.includes('Kalem Seti')) prod = 'XNote Akıllı Kalem ve Defter Seti';
      const name = r.is_anonymous_reviewer ? 'Anonim' : (r.reviewer_name || 'Anonim');
      let title = String(r.title || '').trim(); if (title === '.') title = '';
      const pics = r.pictures_urls || [];
      const el = document.createElement('article');
      el.className = 'xp-rfeed__item';
      Object.assign(el.dataset, { featuredRank: String(rank), reviewProduct: prod, rating: String(r.rating), date, productGroup: prod.includes('Kalem ve Defter') ? 'write' : 'supplies', hasPhoto: String(pics.length > 0) });
      el.innerHTML = '<div class="xp-rfeed__person"><strong>' + esc(name) + '</strong>' + (r.verified_buyer ? '<span>Doğrulanmış alıcı</span>' : '') + '<time datetime="' + date + '">' + date + '</time></div>'
        + '<div class="xp-rfeed__copy"><span class="xp-stars xp-rfeed__stars" role="img" aria-label="5 üzerinden ' + esc(r.rating) + ' yıldız" style="--xp-rating: ' + Number(r.rating) + '"></span><h3>' + esc(title) + '</h3><p>' + esc(body) + '</p><div class="xp-rfeed__photos">'
        + pics.map(ph => '<button type="button" data-xp-rfeed-photo="' + esc(ph.original) + '" data-xp-rfeed-author="' + esc(name) + '" aria-label="' + esc(name) + ' tarafından paylaşılan fotoğrafı büyüt"><img src="' + esc(ph.compact || ph.small) + '" width="72" height="72" loading="lazy" alt="' + esc(name) + ' tarafından paylaşılan müşteri fotoğrafı"></button>').join('')
        + '</div></div>';
      return el;
    }
    async function loadAll() {
      const base = 'https://api.judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(root.dataset.xpRfeedHost || location.hostname) + '&shop_domain=' + encodeURIComponent(shopDomain) + '&platform=shopify&per_page=30&product_id=' + encodeURIComponent(pid);
      const get = n => fetch(base + '&page=' + n).then(r => { if (!r.ok) throw new Error(r.status); return r.json(); });
      const first = await get(1);
      const pages = (first.pagination && first.pagination.total_pages) || 1;
      const rest = await Promise.all(Array.from({ length: pages - 1 }, (_, i) => get(i + 2).catch(() => ({ reviews: [] }))));
      let rank = 1000;
      const added = [];
      [first, ...rest].forEach(d => (d.reviews || []).forEach(r => { const el = build(r, rank++); if (el) added.push(el); }));
      if (!added.length) return;
      added.forEach(el => { el.hidden = true; list.append(el); decorate(el); });
      const offset = entries.length;
      entries = entries.concat(added);
      added.forEach((el, i) => disclosures.push(disclose(el, offset + i)));
      allLoaded = true;
      bars.forEach(b => { b.disabled = !entries.some(r => r.dataset.rating === b.dataset.xpRfeedBar); });
      update();
    }
    if (shopDomain && pid && Number(root.dataset.xpRfeedTotal || 0) > entries.length) {
      const io = new IntersectionObserver(([o]) => { if (o.isIntersecting) { io.disconnect(); loadAll().catch(() => {}); } }, { rootMargin: '800px 0px' });
      io.observe(root);
    }
    controls.hidden = false;
    root.classList.add('is-ready');
    update();
  });
})();
